import type { ComponentProps } from 'react'

import { TripDrawerPresentationProvider } from 'tripPlanner/components/GenericDrawer/TripDrawerPresentationContext'
import { TripChatMobileOverlayProvider } from '../mobile/TripChatMobileOverlayContext'
import { TripListPricingProvider } from '../contexts/TripListPricingContext'
import TripChatMobileSurfaceContent from './TripChatMobileSurfaceContent'

function TripChatMobileSurface(props: ComponentProps<typeof TripChatMobileSurfaceContent>) {
  return (
    <TripListPricingProvider>
      <TripChatMobileOverlayProvider>
        <TripDrawerPresentationProvider>
          <TripChatMobileSurfaceContent {...props} />
        </TripDrawerPresentationProvider>
      </TripChatMobileOverlayProvider>
    </TripListPricingProvider>
  )
}

export type TripChatMobileSurfaceProps = ComponentProps<typeof TripChatMobileSurface>

export default TripChatMobileSurface
